<template>
    <div>
        <el-form ref="formadd"  class="mrt20 " label-position="right" label-width="100px" :model="formData" >
<!--                    <div  class="flex">-->
                        <el-form-item label="是否化验:" class="w50">
                            <template class="flex">
                                <el-radio v-model="formData.i_assayres" :label=1 :disabled="ifdisabled">是</el-radio>
                                <el-radio v-model="formData.i_assayres" :label=0 :disabled="ifdisabled">否</el-radio>
                            </template>
                        </el-form-item>
                        <el-form-item label="卸货是否必检:" class="w50">
                            <template class="flex">
                                <el-radio v-model="formData.i_ismustcheck" :label=1 :disabled="ifdisabled">是</el-radio>
                                <el-radio v-model="formData.i_ismustcheck" :label=0 :disabled="ifdisabled">否</el-radio>
                            </template>
                        </el-form-item>
                        <el-form-item label="是否批次核算:" class="w50">
                            <template class="flex">
                                <el-radio v-model="formData.i_ispno" :label=3 :disabled="ifdisabled">批次</el-radio>
                                <el-radio v-model="formData.i_ispno" :label=0 :disabled="ifdisabled">规格</el-radio>
                            </template>
                        </el-form-item>
<!--                    </div>-->
<!--                    <div  class="flex">-->
                        <el-form-item label="成本核算:">
                            <template class="flex">
                                <el-radio v-model="formData.i_type" :label=2 :disabled="ifdisabled">按大类</el-radio>
                                <el-radio v-model="formData.i_type" :label=1 :disabled="ifdisabled">按规格</el-radio>
                            </template>
                        </el-form-item>
                        <el-form-item label="生产库存核算:">
                            <template class="flex">
                                <el-radio v-model="formData.i_pzid_kcjs" :label=2 :disabled="ifdisabled">按大类</el-radio>
                                <el-radio v-model="formData.i_pzid_kcjs" :label=1 :disabled="ifdisabled">按规格</el-radio>
                            </template>
                        </el-form-item>
                        <el-form-item label="产品属性:" prop="i_flag" class="w50">
                            <el-select style="width: 200px" size="mini" v-model="formData.i_flag" placeholder="产品属性"  filterable required>
                                <el-option
                                        v-for="item in pzsxListData"
                                        :key="item.i_id"
                                        :label="item.vc_name"
                                        :value="item.i_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
<!--                </div>-->
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button @click="resetFormson()">{{$t('button_cancel')}}</el-button>
          <el-button type="primary" @click="saveadd" :disabled="disabled">{{$t('button_save')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from  "./../api";
    import {mapActions} from "vuex";
    import  {file_url} from '@/utils/baseUrl'
    export default {
        name:"adddialog",

        props: {
            idList:{
                type:Array,
                required:true,
            }

        },
        mounted(){
            this.listpzsx()
        },
        data(){
            return{
                formData:{
                    i_assayres:0,
                    i_ismustcheck:0,
                    i_ispno:3,
                    i_type:1,
                    i_pzid_kcjs:1,
                    i_flag:'',
                },
                YorN:[{value:0,label:'否'},{value:1,label:'是'}],
                pzsxListData:[],
                ifdisabled:false,
                disabled:false
            }
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),

            // select(){
            //     let obj=this.pzsxListData.find(f=>f.i_id==this.formData.attr_id);
            //     this.formData.i_flag=obj.i_id
            //     this.$forceUpdate()
            // },
            saveadd(){
                this.$confirm('确认保存?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(  () => {
                   this.edit()
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            async edit(){
                if(this.formData.i_flag!=''){
                    let param=this.formData;
                    param.ids=this.idList;
                    // console.log(param,'111111')
                    // return
                    let res=await API.edit(param);
                    if(res.code==1){
                        this.$emit('close','save')

                    }else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    }
                    else{
                        this.$message.error(res.message);
                    }
                }else{
                    this.$message.warning('产品属性不能为空')
                }


            },
            resetFormson(){
                this.$emit('close','close')
            },
            async listpzsx(){
                let param={
                    // i_mid: this.mid,
                };
                let res=await API.listpzsx(param);
                if(res.code==1){
                    if (res.data.length>0){
                        this.pzsxListData=res.data;
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
        }
    }

</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
        justify-content: space-around;

    }
.inputW{
    width: calc(100% - 100px);
}
    .mrl20{
        margin-left: 20px;
    }

    .mrr50{
        margin-right:100px;
    }

    .cl{
        clear: both;
    }

    .fl{
        float: left;
    }

    .fr{
        float: right;
    }
.w50{
    width: 50%;
}
.w100{
    width: 100%;
}
    .upload-input {
        position: absolute;
        opacity: 0;
        width: 80px;
        height: 100px;
    }

    /deep/{
        /*.upload-input[data-v-a4d5ba82]{*/
        /*    right:160px;*/
        /*    bottom: 10px;*/
        /*}*/
    }
    .el-radio{
        margin-right: 12px;
    }
    .el-radio:last-child{
        margin-right: 0;
    }
</style>